import Vue from 'vue'
import VueRouter from 'vue-router'
import pay from '../components/pay/pay'
import order from '../components/order/order'
import successResult from '../components/successOrFail/success'
import failResult from '../components/successOrFail/fail'
import nganluongData from '../components/nganluongData/nganluongData.vue'

Vue.use(VueRouter)

export default new VueRouter({
routes:[
    {
        path:'/order',
        name:'order',
        component:order
    },
    {
        path:'/',
        name:'pay',
        component:pay
    },
    {
        path:'/successResult',
        name:'success',
        component:successResult
    },
    {
        path:'/failResult',
        name: 'fail',
        component: failResult
    },
    {
        path: '/nganluongData',
        name: 'nganluongdata',
        component: nganluongData
    }
  ]
})



